import {getUrlWithoutDomain} from "@/utilities";

export const useRedirection = async (data = null, optionId = null) => {

    const {seo_url = null} = data || {}

    // redirect the user to original url if the link is not matched with seo_url
    const route = useRoute()

    if (!seo_url) return

    // Append optionId to seo_url if provided
    const url = getUrlWithoutDomain(seo_url)
    let fullSeoUrl = optionId ? `${url}-${optionId}` : url;

    // Compare the current route path with the modified seo_url
    if (getUrlWithoutDomain(fullSeoUrl) !== route.path) await navigateTo(getUrlWithoutDomain(fullSeoUrl), {redirectCode: 301});
};